









































	import Vue from 'vue';
	import Component from 'vue-class-component';
	import ArriveeDeBebe from '@/components/maternite/articles/ArriveeDeBebe.vue';
	import BienVivreMaGrossesse from '@/components/maternite/articles/BienVivreMaGrossesse.vue';

	const Props = Vue.extend({
		props: {
			moisgrossesse: {
				type: Number,
				default: 1
			}
		},
		data: function() {
			return {
				affichertous: false
			};
		},
		methods: {
			toogleAfficherTous: function() {
				this.affichertous= !this.affichertous;
			}
		}
	});

	@Component({
        components: {
			BienVivreMaGrossesse,
			ArriveeDeBebe
        }
    })
	export default class Articles extends Props {
	}
